import { Observable } from 'rxjs';
import { TrafficSource } from '../../../shared/_models/models';
import { FusionApiHttpClient } from '../../../shared/_services/server-clients';

export class TrafficSourcesApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  getAll(): Observable<TrafficSource[]> {
    return this.fusionApiHttpClient.get<TrafficSource[]>('trafficSource/');
  }

  getById(id: number | string): Observable<TrafficSource> {
    return this.fusionApiHttpClient.get<TrafficSource>(`trafficSource/${id}`);
  }

  create(data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.fusionApiHttpClient.post<TrafficSource, Partial<TrafficSource>>(
      'trafficSource/', data
    );
  }

  update(id: number | string, data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.fusionApiHttpClient.put<TrafficSource, Partial<TrafficSource>>(
      `trafficSource/${id}`, data
    );
  }

  delete(id: number | string): Observable<void> {
    return this.fusionApiHttpClient.delete<void>(`trafficSource/${id}`);
  }

  getSspList(): Observable<unknown[]> {
    return this.fusionApiHttpClient.get<unknown[]>('trafficSource/ssp');
  }
}
